import React, { useCallback } from 'react';
import { getIn, type FieldProps } from 'formik';
import { ChipMultiSelectComboBox } from '@discover-ui/comboBox';

export const SUBURB_IDS_UNAVAILABLE_FIELD = '__suburbIdsUnavailable';

type SuburbIdsFieldProps = FieldProps & {
  cityId?: number | null;
  id?: string | null;
};

export default function SuburbIdsField({ field, form, cityId, id }: SuburbIdsFieldProps) {
  const values = form.values as { cityId?: number | string | null };
  const selectedCityIdRaw = values.cityId ?? cityId;
  const selectedCityId =
    selectedCityIdRaw == null || selectedCityIdRaw === '' ? null : Number(selectedCityIdRaw);
  const selectedSuburbIds = Array.isArray(field.value) ? field.value : [];
  const error = getIn(form.errors, field.name);
  const shouldShowError = Boolean(error && form.submitCount > 0);
  const handleOptionsAvailabilityChange = useCallback(
    (hasOptions: boolean) => {
      const unavailable = !hasOptions;
      if (getIn(form.values, SUBURB_IDS_UNAVAILABLE_FIELD) !== unavailable) {
        form.setFieldValue(SUBURB_IDS_UNAVAILABLE_FIELD, unavailable, false);
      }
      if (unavailable && selectedSuburbIds.length > 0) {
        form.setFieldValue(field.name, [], false);
      }
    },
    [field.name, form, selectedSuburbIds.length]
  );

  if (!selectedCityId) {
    return null;
  }

  return (
    <ChipMultiSelectComboBox
      cityId={selectedCityId}
      error={shouldShowError}
      errorMessage={typeof error === 'string' ? error : undefined}
      id={id ?? field.name}
      name={field.name}
      onBlur={() => form.setFieldTouched(field.name, true, false)}
      onOptionsAvailabilityChange={handleOptionsAvailabilityChange}
      value={selectedSuburbIds}
      onValueChange={(nextValue) => {
        form.setFieldValue(field.name, nextValue);
        form.setFieldTouched(field.name, true, false);
      }}
    />
  );
}
